import styles from "../../../styles/map.module.css";
import { useSelector } from "react-redux";
import JDate from "jalali-date";

const Status = () => {
    const [devices, selectedId, positions] = useSelector((state) => {
        return [state.devices.items, state.devices.selectedId, Object.values(state.positions.items)];
    });

    let selectedDevice = (selectedId && devices[selectedId]) || null;
    let selectedDeviceLastPosition = (selectedId && positions.find((Row) => Row.id === selectedDevice.positionId)) || null;

    let selectedDeviceLastUpdate = () => {
        if (selectedDevice) {
            let date = new Date(selectedDevice.lastUpdate);
            return new JDate(date).format("YYYY/MM/DD ") + date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds();
        }
        return "-";
    };

    return (
        <div className={styles.status}>
            <div data-for="Tooltip" data-tip={(selectedDevice && selectedDevice.status === "online" ? "آنلاین" : "آفلاین") || "---"} className={styles.div}>
                <img src={(selectedDevice && selectedDevice.status === "online" ? "./images/green.png" : "./images/red.png") || "./images/red.png"} className={styles.status1} alt={"logo"} />
                <div className={styles.text}>وضعیت</div>
            </div>

            <div className={styles.div}>
                <div className={styles.text}>نام</div>
                <div className={styles.text1}>{selectedDevice && selectedDevice.name}</div>
            </div>

            <div className={styles.div}>
                <div className={styles.text}>آخرین بروزرسانی</div>
                <div className={styles.text1}>{selectedDeviceLastUpdate()}</div>
            </div>

            <div className={styles.div}>
                <div className={styles.text}>آخرین سرعت</div>
                <div className={styles.text1}>{(selectedDeviceLastPosition && (selectedDeviceLastPosition.speed * 1.852).toFixed(2)) || "0.00"}Km/h</div>
            </div>
            <div className={styles.div}>
                <div className={styles.text}>آخرین عرض</div>
                <div className={styles.text1}>{(selectedDeviceLastPosition && selectedDeviceLastPosition.latitude) || "0"}</div>
            </div>
            <div className={styles.div}>
                <div className={styles.text}>آخرین طول</div>
                <div className={styles.text1}>{(selectedDeviceLastPosition && selectedDeviceLastPosition.longitude) || "0"}</div>
            </div>
            <div className={styles.div}>
                <div className={styles.text}>مسافت طی شده</div>
                <div className={styles.text1}>{(selectedDeviceLastPosition && selectedDeviceLastPosition.attributes.distance) || "0"}km/h</div>
            </div>
            <div className={styles.div}>
                <div className={styles.text}>باتری</div>
                <div className={styles.text1}>{(selectedDeviceLastPosition && selectedDeviceLastPosition.attributes.batteryLevel) || "0"}%</div>
            </div>
        </div>
    );
};

export default Status;
